<template>
  <div class="row" style="margin: 0 -15px 15px 0">
    <div class="col-md-12 cleafix">
      <div class="right-buttons" style="float:right">
        <button class="btn btn-circle default btn-sm" @click="$emit('togglePause')">
          <i
            class="fa"
            aria-hidden="true"
            :class="withPause ? 'fa-pause-circle' : 'fa-play-circle'"
          ></i>
          {{ withPause ? "ΜΕ" : "ΧΩΡΙΣ" }} ΠΑΥΣΗ
        </button>
        
        <button class="btn btn-circle default btn-sm" @click="$emit('toggleSound')">
          <i
            class="fa"
            :class="withSound ? 'fa-volume-up' :'fa-volume-off'"
            aria-hidden="true"
            style="margin-right: 0"
          ></i>
          {{ withSound ? "ΜΕ" : "ΧΩΡΙΣ" }} ΗΧΟ
        </button>
        
        <button class="btn btn-circle default btn-sm" @click="$emit('toggleTheme')">
          <i class="fa fa-refresh" aria-hidden="true"></i> ΠΕΡΙΒΑΛΛΟΝ
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Report from "./Report.vue";
import ExplanationModal from "./ExplanationModal.vue";

export default {
  props: ["question", "withSound", "withPause", "showToolbar"],
  methods: {
    changeLanguage(lang) {
      this.question.changeLang(lang);
    },
    forceModalOpen() {
      setTimeout(() => {
        this.$refs.modal.openModal();
      }, 200);
    }
  },
  components: { ExplanationModal, Report }
};
</script>